define('taoQtiItem/qtiItem/core/variables/OutcomeDeclaration',['taoQtiItem/qtiItem/core/variables/VariableDeclaration'], function(VariableDeclaration){
    return  VariableDeclaration.extend({
        qtiClass : 'outcomeDeclaration'
    });
});
